import * as React from 'react';
import { Direction, sortByProperty } from '../Helpers/SortHelper';
import { JobVacancy } from '../Model/JobVacancy';
import { StaticSettings } from '../StaticSettings';
import { ApplyNowButtonWidget } from './Button/ApplyNowButtonWidget';
import { Grid } from './JobVacancy/Grid';
import { Groups } from './JobVacancy/Groups';
import { ListProps } from './ListProps';
import { ListStyle } from './ListStyle';
import { Trans } from './Trans';

export class JobVacancyList extends React.Component<ListProps<JobVacancy>> {
    public render() {
        const props = this.props;
        const allModels = props.allModels;
        const filteredModels = props.filteredModels;

        if (allModels.length === 0) {
            return this.renderEmpty();
        }
        if (filteredModels.length === 0) {
            return <>
                {this.renderNoResults()}
                <ApplyNowButtonWidget selectedModels={props.selectedJobVacancies}/>
            </>;
        }

        const sortProperty = StaticSettings.ui.list.jobVacancySortBy;
        if (sortProperty !== undefined) {
            return this.renderWithFilteredModels(sortByProperty(filteredModels, sortProperty, Direction.Desc), props);
        } else {
            return this.renderWithFilteredModels(filteredModels, props);
        }
    }

    private renderWithFilteredModels(
        filteredModels: JobVacancy[],
        props: Readonly<ListProps<JobVacancy>>
    ) {
        switch (StaticSettings.ui.list.style) {
            case ListStyle.Grouped: {
                return <>
                    <Groups {...props} />
                    <ApplyNowButtonWidget selectedModels={props.selectedJobVacancies}/>
                </>;
            }
            case ListStyle.Grid: {
                return <>
                    <Grid {...props} filteredModels={filteredModels}/>
                    <ApplyNowButtonWidget selectedModels={props.selectedJobVacancies}/>
                </>;
            }
        }
    }

    private renderEmpty() {
        return <h2><Trans>Im Moment sind keine Stellenangebote vorhanden</Trans></h2>;
    }

    private renderNoResults() {
        return <h2><Trans>Es konnten keine Angebote entsprechend Ihrer Suche gefunden werden.</Trans></h2>;
    }
}
